export default __webpack_public_path__ + "static/media/bigl.4e7ca2bb.svg";